// extracted by mini-css-extract-plugin
export default {"loadingPage":"styles_loadingPage__yVHvN","logo":"styles_logo__ijsnb"};